// extracted by mini-css-extract-plugin
export default {"image":"AlALOc","card":"DG4ltS","section":"Ngk8GC","quoteBlock":"PhArN4","inverted":"OU7bfQ","imageAndText":"qM2h9w"};